import React, { useState } from 'react';
import {
  LayoutDashboard,
  Music,
  MapPin,
  BadgeCheck,
  Building2,
  Dumbbell,
  Shield,
  Users,
  Wallet,
  Settings,
  LogOut,
  ChevronDown,
  ChevronRight,
  Menu,
  CheckCircle,
  Flame,
  Ticket,
  Film,
} from 'lucide-react';

export default function SidebarNav({
  activeTab,
  setActiveTab,
  artistsCount = 0,
  tracksCount = 0,
  approvalsCount = 0,
  collapsed,
  setCollapsed,
  onLogout,
}) {
  const [dashboardExpanded, setDashboardExpanded] = useState(true);

  const mainTabs = [
    { id: 'dashboard', label: 'Overview', icon: LayoutDashboard },
    { id: 'approvals', label: 'Approvals Queue', icon: CheckCircle, badge: approvalsCount > 0 ? approvalsCount : null },
    { id: 'parties', label: 'Warm Home Parties', icon: Flame },
    { id: 'bookings', label: 'Party Bookings & Escrow', icon: Ticket },
    { id: 'loka', label: 'Rap Map', icon: MapPin },
    { id: 'music', label: 'Music & Anthems', icon: Music, badge: tracksCount > 0 ? tracksCount : null },
    { id: 'artists', label: 'Artist Verifications', icon: BadgeCheck, badge: artistsCount > 0 ? artistsCount : null },
    { id: 'properties', label: 'Properties', icon: Building2 },
    { id: 'fitness', label: 'Fitness & Sports', icon: Dumbbell },
    { id: 'captains', label: 'Captains Directory', icon: Shield },
    { id: 'users', label: 'Users Directory', icon: Users },
    { id: 'finance', label: 'Finance & Ledger', icon: Wallet },
    { id: 'settings', label: 'Settings & Video Upload', icon: Settings },
  ];

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* 4 Corner Brackets for Sidebar Panel */}
      <span className="corner-tl" />
      <span className="corner-tr" />
      <span className="corner-bl" />
      <span className="corner-br" />

      {/* Sidebar Top Header Toggle */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', padding: '0 4px' }}>
        {!collapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="pulse-dot"></span>
            <span style={{ fontSize: '0.72rem', fontWeight: 800, color: 'var(--neon-green)', letterSpacing: '0.06em', fontFamily: 'var(--font-mono)' }}>
              SYSTEM READY
            </span>
          </div>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            padding: '4px',
            marginLeft: collapsed ? 'auto' : '0',
          }}
          title={collapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
        >
          <Menu size={18} />
        </button>
      </div>

      {/* Tree Category Heading */}
      <div style={{ flex: 1 }}>
        <div style={{ marginBottom: '12px' }}>
          {!collapsed && (
            <div
              onClick={() => setDashboardExpanded(!dashboardExpanded)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 10px',
                borderRadius: '6px',
                color: 'var(--neon-green)',
                fontWeight: 800,
                fontSize: '0.82rem',
                cursor: 'pointer',
                background: 'rgba(0, 255, 135, 0.08)',
                marginBottom: '8px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <LayoutDashboard size={16} />
                <span>Dashboards</span>
              </div>
              {dashboardExpanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
            </div>
          )}

          {(dashboardExpanded || collapsed) && (
            <div className="sidebar-menu" style={{ paddingLeft: collapsed ? 0 : '8px' }}>
              {mainTabs.map((item) => {
                const IconComponent = item.icon;
                const isActive = activeTab === item.id;

                return (
                  <div
                    key={item.id}
                    className={`sidebar-item ${isActive ? 'active' : ''}`}
                    onClick={() => setActiveTab(item.id)}
                    title={collapsed ? item.label : ''}
                  >
                    {!collapsed && <span style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginRight: '-4px' }}>-</span>}
                    <IconComponent size={15} style={{ color: isActive ? 'var(--neon-green)' : 'var(--text-muted)', flexShrink: 0 }} />
                    {!collapsed && <span style={{ fontSize: '0.82rem' }}>{item.label}</span>}

                    {!collapsed && item.badge !== null && item.badge !== undefined && (
                      <span className="sidebar-badge">{item.badge}</span>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* Logout Action Footer */}
      <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '12px', marginTop: 'auto' }}>
        <button
          onClick={onLogout}
          className="sidebar-item"
          style={{
            width: '100%',
            background: 'rgba(255, 51, 102, 0.12)',
            color: 'var(--neon-rose)',
            borderColor: 'rgba(255, 51, 102, 0.3)',
          }}
        >
          <LogOut size={16} style={{ color: 'var(--neon-rose)', flexShrink: 0 }} />
          {!collapsed && <span>System Logout</span>}
        </button>
      </div>
    </aside>
  );
}
